'use client'

import { PageProviderServer } from './PageProvider'
import HashFixer from '../../components/HashFixer/HashFixer'
import SetClientCookie from 'components/SetClientCookie/SetClientCookie'
import { initFeatureFlags } from '@/utils/featureFlags'

/**
 * Minimal client entry for the page shell: cookie/hash utilities only.
 * Feature flags, graduate modal, DTI, and `Layout` are composed from the server `PageProvider`
 * via RSC wrappers (`*ProviderServer`) + `PageLayoutClient`.
 */
export function PageProviderClient({ children, pageProps }: PageProviderServer) {
  initFeatureFlags(pageProps?.featureToggleObject || {}, pageProps?.featurePathOverrides || {})

  return (
    <>
      <HashFixer />
      <SetClientCookie cookies={pageProps?.cookiesToSet} />
      {children}
    </>
  )
}
